import {LocationDto, LocationType} from "src/types/Location";

export type CampusLocationType = LocationDto &
  LocationType & {
    displayName?: string;
    imageUrl?: string;
    id: string;
    locationType: string;
  };

export enum CampusLocationCategory {
  Dining = 'Dining',
  ScanAndPay = 'ScanAndPay',
  Vending = 'Venidng',
}